import { render, staticRenderFns } from "./KrokResultsWrapper.vue?vue&type=template&id=769d9f13"
import script from "./KrokResultsWrapper.vue?vue&type=script&lang=js"
export * from "./KrokResultsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports